<template>
  <div class="record-wrapper">
    <div class="time">
      {{ timestamp || dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss') }}
    </div>
    <div v-if="from == userInfo.userNo" class="msg msg-right">
      <div class="img-wrapper">
        <img class="img" :src="from1" />
      </div>
      <div class="message-wrapper message-wrapper-right">
        <div class="message" v-if="messageType == '1'">{{ message }}</div>
        <div v-else class="message">
          <img
            :src="message"
            :preview="uuid(16)"
            :large="message"
            @error="setDefaultImage"
            @load="loadOk"
            alt
          />
        </div>
      </div>
    </div>

    <div v-else class="msg msg-left">
      <div class="img-wrapper">
        <img class="img" :src="from2" />
      </div>
      <div class="message-wrapper message-wrapper-left">
        <div class="message" v-if="messageType == '1'">{{ message }}</div>
        <div class="message" v-else>
          <img
            :src="message"
            :preview="uuid(16)"
            @error="setDefaultImage"
            :large="message"
            @load="loadOk"
            alt
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon from '@/assets/img/doc.png'
import icon1 from '@/assets/img/user.png'
import errimg from '@/assets/img/errimg.png'
import dayjs from 'dayjs'
import { uuid } from '@/utils'
export default {
  name: '',
  props: {
    from: [Number, String], // 1: 发送id
    messageType: [String, Number], // 1: 文字    2: 图片
    message: String,
    timestamp: String,
    doctorNo: [String, Number] // 医生id
  },
  components: {},
  data() {
    return {
      dayjs,
      from1: icon1,
      from2: icon,
      errimg
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$previewRefresh()
    })
  },
  created() {
    this.userInfo =
      sessionStorage.getItem('userInfo') &&
      JSON.parse(sessionStorage.getItem('userInfo'))
  },
  mounted() {
    this.$previewRefresh()
  },
  methods: {
    uuid,
    loadOk() {
      this.$emit('ItemImageLoad')
    },
    setDefaultImage(e) {
      console.log(e)
      e.target.src = this.errimg
      e.target.style.pointerEvents = 'none' //显示错误禁止点击
      setTimeout(() => {
        this.$previewRefresh()
      }, 2000)
    }
  }
}
</script>
<style lang="scss" scoped>
.record-wrapper {
  margin: 4px;
  padding: 4px;
}
.time {
  text-align: center;
}
.msg {
  display: flex;
  flex-direction: row;

  .message-wrapper {
    max-width: 220px;
    margin: 0px 10px 0px 10px;
    .message {
      margin: 8px;
      word-wrap: break-word; //英文换行
    }
    img {
      min-width: 50px;
      max-width: 50px;
      min-height: 50px;
      max-height: 50px;
      object-fit: contain;
    }
  }

  .message-wrapper-left {
    background-color: lightslategray;
    border-radius: 0px 12px 12px 12px;
  }

  .message-wrapper-right {
    background-color: powderblue;
    border-radius: 12px 0px 12px 12px;
  }

  .img {
    flex: auto;
    height: 36px;
    width: 36px;
    border-radius: 8px;
  }
}
.msg-right {
  flex-direction: row-reverse;
}
.msg-left {
  flex-direction: row;
}
</style>
